export default __webpack_public_path__ + "435c9132cd004b352254083fd1fc37d2.webp";